import { TitleTag } from "@/components/shared/item";
import {
  CommonContainer,
  CommonPageContainer,
} from "@/components/ui/container";
import { CommonTitleTwo } from "@/components/ui/fonts/Fonts";
import { mq } from "@/libs/react-responsive/mediaQuery";
import { color, image } from "@/theme";
import styled from "@emotion/styled";
import React from "react";

const PageTitle = styled(CommonTitleTwo)(() => ({
  margin: "2rem 0",
  textAlign: "center",
}));

const StyledImage = styled.img(() => ({
  display: "block",
  maxWidth: "100%",
  margin: "0 auto",

  [mq("tablet")]: {
    maxWidth: "90%",
  },
}));

const Title = styled.h1(() => ({
  fontSize: "2rem",
  fontWeight: "bold",
  textAlign: "center",
  marginTop: "8rem",
  marginBottom: "4rem",

  [mq("desktop")]: {
    fontSize: "2.4rem",
  },
}));

const Description = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  fontSize: "1.8rem",
  gap: "4rem",
  textAlign: "center",
  margin: "2rem auto",
  lineHeight: 2,

  strong: {
    color: color.primary02,
  },

  b: {
    display: "block",
    marginTop: "2rem",
  },

  p: {
    fontSize: "1.6rem",
    marginBottom: "2rem",
  },

  [mq("desktop")]: {
    gap: "1rem",
    fontSize: "2rem",
    maxWidth: "80%",
  },
}));

const InformationSection = styled.div(() => ({
  display: "flex",
  margin: "6rem 0 8rem",
  textAlign: "center",
  fontSize: "1.8rem",
  flexDirection: "column",

  [mq("desktop")]: {
    margin: "6rem 0 15rem",
  },
}));

const InformationItem = styled.div(({ noBorder }) => ({
  flex: 1,
  alignSelf: "stretch",
  fontSize: "1.6rem",
  color: color.black01,

  header: {
    border: `1px solid ${color.grey04}`,
    flex: 1,
    fontWeight: 600,
    padding: "1rem 0",
  },

  "& > div": {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "2rem 0",
    border: `1px solid ${color.grey04}`,
    borderTop: 0,
    borderBottom: noBorder ? "none" : `1px solid ${color.grey04}`,

    flex: 1,
    height: "100%",
  },

  p: {
    color: color.primary02,
    fontWeight: "bold",
  },

  ul: {
    display: "flex",
    flexDirection: "column",
    gap: "3.2rem",
  },

  [mq("desktop")]: {
    fontSize: "1.8rem",
  },
}));

const ClosingText = styled.div(() => ({
  margin: "8rem 0",
}));

const TagList = styled.ul(() => ({
  marginTop: "8rem",
  display: "flex",
  gap: "0.8rem 0rem",
  maxWidth: "100%",
  flexWrap: "wrap",
  justifyContent: "center",
  alignItems: "center",

  span: {
    display: "inline-block",
    padding: "0.5rem 1rem",
    borderRadius: "2rem",
    background: color.grey05,
    color: "white",
    fontSize: "1.4rem",
    lineHeight: "1",
    whiteSpace: "nowrap",
    marginRight: "1rem",
  },
}));

const NoticeText = styled.div(() => ({
  fontSize: "1.3rem",
  marginTop: "1rem",

  [mq("desktop")]: {
    textAlign: "right",
    fontSize: "1.4rem",
  },
}));

const ShortFormCampaignResult = () => {
  return (
    <CommonPageContainer>
      <CommonContainer>
        <TitleTag title="65초 안에 지구를 지켜줘!" bgColor={color.primary02} />

        <PageTitle>
          <p>제 2회 세이브더얼스 환경소재 숏폼 공모전</p>

          <p>65초 안에 지구를 지켜줘!</p>
        </PageTitle>

        <StyledImage src={image.campaignResult} alt="campaign-result" />

        <Title>🌱 제2회 세이브더얼스 숏폼영상 공모전 결과 발표</Title>

        <Description>
          <div>
            사단법인 세이브더얼스가 주최한 6월 5일 환경의 날 기념 제2회 환경소재
            숏폼영상 공모전 <br />
            <strong>‘65초 안에 지구를 지켜줘’</strong> 에 참여해 주신 모든
            참가자 여러분께 진심으로 감사드립니다.
          </div>

          <div>
            <p>
              이번 공모전에는 환경과 지속가능성에 대한 다양한 시선과 진솔하고
              진정성 있는 메시지가 담긴 많은 작품들이 접수되었습니다.
            </p>

            <p>
              작품 하나하나를 통해 환경을 생각하는 각자의 고민과 열정을 느낄 수
              있었으며, 심사 과정에서도 많은 감동과 울림을 전해주었습니다.
            </p>

            <p>
              수상 여부와 관계없이 이번 공모전에 참여해 주신 모든 분들의 관심과
              노력이 환경을 위한 소중한 실천이자 변화의 시작이라고 생각합니다.
            </p>

            <p style={{ marginTop: "2rem" }}>
              소중한 시간을 내어 함께해 주신 모든 참가자 여러분께 다시 한번
              감사드리며, <br />
              앞으로도 환경을 위한 다양한 활동과 도전을 이어가시길
              응원하겠습니다.
            </p>
          </div>
        </Description>

        <InformationSection>
          <InformationItem>
            <header>🌱 수상자 명단</header>

            <div>
              <ul>
                <li>
                  <div>[대 상 (정미혜 이사장 상)] (1명)</div>

                  <p>-김 ○ 은 [편리함의 대가]</p>
                </li>

                <li>
                  <div>[최 우 수 상 (세이브더얼스 상)] (2명)</div>

                  <p>-변 ○ 빈 [같은 하루 다른 선택]</p>
                  <p>-조 ○ 대 [The Real Problem]</p>
                </li>

                <li>
                  <div>[우 수 상 (환경지킴이 상)] (3명)</div>

                  <p>-김 ○ 석 [돌고 돌아, 결국 우리 가족의 입으로]</p>
                  <p>-김 ○ 오 [너도 해봐! Earth Saver]</p>
                  <p>-정 ○ 성 [환경파괴 영수증]</p>
                </li>

                <li>
                  <div>[크리에이티브상] (4명)</div>

                  <p>-한 ○ 민 [65초로 지구를 바꿀 수 있습니다]</p>
                  <p>-김 ○ 지 [우리가 만드는 물결(동물보호)]</p>
                  <p>-김 ○ 영 [꼬 리]</p>
                  <p>-김 ○ 환 [대기오염의 범인]</p>
                </li>
              </ul>
            </div>
          </InformationItem>
        </InformationSection>

        <div>
          <InformationSection>
            <InformationItem noBorder={true}>
              <header>🌱 시 상 식 </header>

              <div> - 2026년 6월 13일 (토요일)</div>
            </InformationItem>

            <InformationItem>
              <header>🌱 시 상 내 역 </header>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <div>- 총 상 금 : 510만원</div>
                <div>- 대 상 : 200만원 X 1(인)</div>
                <div>- 최 우 수 상 : 100만원 X 2(인)</div>
                <div>- 우 수 상 : 30만원 X 3(인)</div>
                <div>- 크리에이티브상 : 5만원 (디지털상품권) X 4(인)</div>
              </div>
            </InformationItem>
            <NoticeText>
              <p>
                ※ 시상식 일정 및 수상 관련 안내는 개별 연락을 통해 진행됩니다.
              </p>
              <p>[대상 / 최우수상 / 우수상 수상자]</p>
            </NoticeText>
          </InformationSection>
        </div>

        <ClosingText>
          <Description>
            <div>
              사단법인 세이브더얼스는 앞으로도 환경을 지키는 뜻깊은 활동과{" "}
              <br />
              창의적 참여의 장을 마련하기 위해 꾸준히 노력하겠습니다.
            </div>

            <b>
              <section>다시 한 번, 귀중한 작품으로 함께해 주신</section>{" "}
              <section>모든 분들께 감사드립니다.</section>
            </b>
          </Description>

          <TagList>
            <span>#환경의날</span> <span>#세이브더얼스</span>{" "}
            <span>#세이브더얼스공모전</span> <span>#지구를지켜줘</span>{" "}
            <span>#savetheearth</span>
          </TagList>
        </ClosingText>
      </CommonContainer>
    </CommonPageContainer>
  );
};

export default ShortFormCampaignResult;
